import { WidgetData } from '@playbooks/core/src/interfaces'

import { BaseNode } from '../../'

export class WidgetNode<T extends WidgetData = WidgetData> extends BaseNode<T> {
  public get buttonLabel(): string {
    return this.data.buttonLabel
  }

  public getCode(): string | undefined | null {
    return this.data.code
  }

  public get autoLaunch(): boolean {
    return this.data.autoLaunch || false
  }
}
